import { IDeducoes } from 'interfaces/IDeducao';
import { INovaGuiaRecolhimento, IReceberDadosGuiaRecolhimento } from 'interfaces/IGuiaRecolhimento';
import {
  INcmPrimeiroAdquirenteEnviar,
  INcmPrimeiroAdquirenteLista,
  INcmPrimeiroAdquirenteReceber,
} from 'interfaces/IPrimeiroAdquirente';
import { IProcessoMinerario } from 'interfaces/IProcessoMinerario';
import { useApiClient } from '../../../hooks/useApiClient';

export const useBackEndRequests = () => {
  const httpCall = useApiClient();

  const postGuiaRecolhimento = async (payload: INovaGuiaRecolhimento) => {
    await httpCall
      .post(`/arrecadacao/api/guia-recolhimento`, payload)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const putGuiaRecolhimento = async (payload: INovaGuiaRecolhimento) => {
    await httpCall
      .put(`/arrecadacao/api/guia-recolhimento`, payload)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const deleteGuiaRecolhimento = async (idGuiaRecolhimento: string) => {
    await httpCall
      .delete(`/arrecadacao/api/guia-recolhimento/${idGuiaRecolhimento}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getPermissaoAcessarGuiaRecolhimento = async (idGuiaRecolhimento: string) => {
    const resposta = await httpCall.get(
      `/arrecadacao/api/guia-recolhimento/validar-permissao-guia-recolhimento/${idGuiaRecolhimento}`
    );
    return resposta.status;
  };

  const getCopiarGuia = async (idGuiaRecolhimento: string) => {
    const resposta = await httpCall.get<string>(`/arrecadacao/api/guia-recolhimento/copiar/${idGuiaRecolhimento}`);
    return resposta.data;
  };

  const getDadosRecolhimento = async (idGuiaRecolhimento: string) => {
    const resposta = await httpCall.get<IReceberDadosGuiaRecolhimento>(
      `/arrecadacao/api/guia-recolhimento/${idGuiaRecolhimento}`
    );
    return resposta.data;
  };

  const getProcessoMinerarioPorNumero = async (numero: string) => {
    const resposta = await httpCall.get<IProcessoMinerario>(
      `/arrecadacao/api/processo-minerario/lavra-garimpeira/${numero}`
    );

    return resposta.data;
  };

  const postNCM = async (payload: INcmPrimeiroAdquirenteEnviar) => {
    await httpCall
      .post(`/arrecadacao/api/guia-recolhimento/primeiro-adquirente/base-calculo`, payload)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const putNCM = async (payload: INcmPrimeiroAdquirenteEnviar) => {
    await httpCall
      .put(`/arrecadacao/api/guia-recolhimento/primeiro-adquirente/base-calculo`, payload)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const deleteNCM = async (idNCM: number) => {
    await httpCall
      .delete(`/arrecadacao/api/guia-recolhimento/primeiro-adquirente/base-calculo/${idNCM}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getNCM = async (idNCM: number) => {
    const resposta = await httpCall.get<INcmPrimeiroAdquirenteReceber>(
      `/arrecadacao/api/guia-recolhimento/primeiro-adquirente/base-calculo/${idNCM}`
    );
    return resposta.data;
  };

  const getListaNCM = async (idGuiaRecolhimento: string) => {
    const resposta = await httpCall.get<INcmPrimeiroAdquirenteLista>(
      `/arrecadacao/api/guia-recolhimento/primeiro-adquirente/base-calculo/todos/${idGuiaRecolhimento}`
    );
    return resposta.data;
  };

  const getDeducoes = async (idDaGuiaRecolhimento: string) => {
    const resposta = await httpCall.get<IDeducoes>(
      `/arrecadacao/api/tributos/primeiro-adquirente?idDaGuiaRecolhimento=${idDaGuiaRecolhimento}`
    );
    return resposta.data;
  };

  return {
    postGuiaRecolhimento,
    putGuiaRecolhimento,
    deleteGuiaRecolhimento,
    getPermissaoAcessarGuiaRecolhimento,
    getCopiarGuia,
    getDadosRecolhimento,
    getProcessoMinerarioPorNumero,
    postNCM,
    putNCM,
    deleteNCM,
    getNCM,
    getListaNCM,
    getDeducoes,
  };
};
